import { InjectionToken } from '@angular/core';

export const PUBLISHERS_FILE_CONFIGURATION_TOKEN = new InjectionToken<string>(
  `Configure Publishers File Path`
);
